/**
 * Backbone model which describes a bound `Operation`.
 */
import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
/**
 * Backbone model which describes a bound `Operation`.
 */
var BoundOperation = Backbone.Model.extend({
  defaults: {
    text: "Default Text",
    icon: "",
  },

  initialize: function (attributes, options) {
    var action = attributes.action,
      available = attributes.available;

    if (_.isFunction(action)) {
      this.action = this._action = _.bind(function (model, options) {
        return action.apply(this, arguments).done(
          _.bind(function (model) {
            this.trigger(this.id, model, options);
          }, this)
        );
      }, this);
      delete attributes.action;
    }

    if (_.isFunction(available)) {
      this.available = this._available = _.bind(available, this);
      delete attributes.available;
    }

    this.unbind = this.unwrap = function () {
      return options.parent;
    };

    Backbone.Model.prototype.initialize.apply(this, arguments);
  },

  /**
   * Creates a new BoundOperation which executes the given function before continuing to the core operation.
   * @param  {Function} before The function to execute, which is given the model associated with the operation and the options hash, if any. The function is expected to return a promise, and is called before the core operation executes.
   * @return {BoundOperation}        A new BoundOperation which incorporates the additional functionality. Call `unbind` or `unwrap` to access the original BoundOperation
   */
  wrap: function (before) {
    var self = this;
    var result = new BoundOperation(
      _.extend({}, this.attributes, {
        available: this.available,
      }),
      {
        parent: this,
      }
    );

    result.action = function (model, options) {
      return before(model, options).then(function () {
        self.action(model, options);
      });
    };

    return result;
  },

  /**
   * Creates a new BoundOperation which defaults to using the given model and options if no model or options are supplied.
   * @param  model The default model.
   * @param {Object} [options] The options hash.
   * @return {BoundOperation}       The generated operation.
   */
  withModel: function (model, options) {
    var self = this;

    return new BoundOperation(
      _.extend({}, this.attributes, {
        action: function (suppliedModel, suppliedOptions) {
          return self._action(
            suppliedModel || model,
            suppliedOptions || options
          );
        },
        available: function (suppliedModel) {
          return self._available(suppliedModel || model);
        },
      }),
      {
        parent: this,
      }
    );
  },
});

export default BoundOperation;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/models/BoundOperation.js
// module id = 211
// module chunks = 1